<nav class="link-list col-sm-12" [attr.aria-labelledby]="id()">
  <h3 [id]="id()" *scText="title()" class="link-list--title m-0"></h3>

  <ul class="link-list--list w-100 p-0 m-0">
    @for (link of linkList(); track link.id) {
      @if (showLink(link.value)) {
        <li
          class="link-list--list-item position-relative d-flex m-0"
          [class.border-top]="$index > 0"
        >
          <a
            *wlGenericLink="link.value"
            class="link-list--link stretched-link flex-grow-1"
            wlTrackLink
            [trackLinkInfo]="{
              rendering: { componentName: 'LinkListComponent' },
              field: link.value?.value?.text ?? '',
              eventType: 'link-click',
              type: 'navigation',
            }"
          ></a>
          <crnt-icon class="link-list--link-icon p-2" icon="chevron-right" />
        </li>
      }
    }
  </ul>
</nav>
